<div class="confirm-container">
  <div class="confirm-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
      <path d="M12 3 1.5 21h21L12 3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M12 9.5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="17" r="1" fill="currentColor" />
    </svg>
  </div>

  @if (!isAllDisband) {
    <h4 class="confirm-title">Remove Character From Party?</h4>
    <div class="confirm-content">
      <p>The character will be removed from the party. Pins they placed will remain in their own timeline.</p>
      <p>Pins placed by the Game Master will transition into that character&rsquo;s journey timeline, so the story stays intact for solo or group play later.</p>
      <p class="confirm-note">Proceed only if you&rsquo;re ready to part ways.</p>
    </div>
    <div class="btn-sec">
      <button class="btn btn-outline" (click)="closeModal()">Cancel</button>
      <button class="btn btn-danger" (click)="disbandPlayers()">Remove</button>
    </div>
  } @else {
    <h4 class="confirm-title">Disband This Party?</h4>
    <div class="confirm-content">
      <p>This marks the end of your shared journey &mdash; the whole party will be disbanded.</p>
      <p>Pins placed by the Game Master will transition into each character&rsquo;s own journey timeline, so the story stays intact for solo or group play later.</p>
      <p class="confirm-note">Proceed only if you&rsquo;re ready to part ways and forge ahead on separate paths.</p>
    </div>
    <div class="btn-sec">
      <button class="btn btn-outline" (click)="closeModal()">Cancel</button>
      <button class="btn btn-danger" (click)="disbandPlayers()">Disband party</button>
    </div>
  }
</div>
